// extracted by mini-css-extract-plugin
module.exports = {"title":"member_title__MUJ6z","links":"member_links__1gZLu"};